<template>
  <div class="form-wrapper">
    <div class="form-title">{{ props.title }}</div>
    <div class="form-borded-inner">
      <slot name="inner"></slot>
    </div>
  </div>

</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps(['title']);

</script>

<style lang="scss" scoped>
.form-borded-inner{
  border: 1px solid #4d4d4d;
  border-radius: 10px;
}
.form-title{
  text-transform: uppercase;
  color: #4d4d4d;
  margin-bottom: 0.5em;
  font-size: 0.8em;
  font-weight: bold;
}
</style>